var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c("b", [_vm._v("Group Sharing")]),
              _vm._v(" "),
              _vm.isOrgAdmin && _vm.hasMoreGroupsToShareWith
                ? _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.hasGroups,
                          expression: "hasGroups"
                        }
                      ],
                      staticClass: "float-right",
                      attrs: {
                        disabled: "",
                        type: "button",
                        variant: "outline-primary",
                        size: "sm"
                      }
                    },
                    [
                      _c("span", { staticClass: "button-text" }, [
                        _vm._v("Share with")
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.shareCseitRecords.length > 0
            ? _c(
                "div",
                _vm._l(_vm.shareCseitRecords, function(sp) {
                  return _c(
                    "b-list-group",
                    { key: sp.id, attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.toggleUpdateShareCseitModal(sp.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm._.get(sp, "sgroup.groupName", "Unknown")
                                ) +
                                " "
                            ),
                            _c("img", {
                              attrs: {
                                src:
                                  "/static/img/" +
                                  (sp.cseitShareStatus
                                    ? "shareYes.png"
                                    : "shareNo.png"),
                                height: "21",
                                width: "21"
                              }
                            })
                          ]
                        )
                      ])
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.shareCseitRecords.length === 0
            ? _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              !_vm.hasGroups
                                ? "Your organization does not belong to any groups"
                                : "This record is not currently shared"
                            )
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("UpdateShareCseitModal", {
        attrs: {
          cseitId: _vm.cseitId,
          cseitOrganizationOwner: _vm.cseitOrganizationOwner,
          shareRecord: _vm.shareRecord,
          groupId: _vm.selectedGroup
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1da79244", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1da79244","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cseit/ShareCseitList.vue
// module id = 1751
// module chunks = 0